import { partialRepaymentOutput } from './../services/PartialRepaymentCalc';
import { getLtvValue } from './../services/LtvCalc';

const defaultInput = {
  clientAge: 55,
  loanTaken: 50000,  //
  interestTaken: 2.5, // aka loanAPR, 3..8%
  housePrice: 400000,  // G6
  futureHousePricePct: 0, // G13, -1%.. 1%, step 0.25
  capitalValue: 1000,
  stopPartialRepayment: 10, // stop after N years
  stopPayingOffInterest: 5,
  period: 12, // yearly
  ltvPlan: '',
  isJoint: false, // single or joint
};

const yearlyCapitalValue = ({ period, capitalValue }) => {
  return (12.0 / period) * parseInt(capitalValue, 10)
};


const updateInputOutput = ({ input, output }) => {
  const validLoan = !isNaN(input.loanTaken) && parseInt(input.loanTaken,10) > 0
  const validCapitalValue = !isNaN(input.capitalValue) && parseInt(input.capitalValue,10) > 0;
  output.yearlyCapitalValue = yearlyCapitalValue(input)
  output.maxYearlyLoan = parseInt(input.loanTaken * 0.1, 10);

  if (validLoan && validCapitalValue && output.maxStopAfter > 0) {
    const hasError = output.yearlyCapitalValue > output.maxYearlyLoan;
    if (!hasError && input.stopPartialRepayment > output.maxStopAfter) {
      input.stopPartialRepayment = output.maxStopAfter;
    }
  }
  if (input.clientAge < 55) {
    input.clientAge = 55;
  }
  // if (input.clientAge === 55 && input.isJoint) {
  //   input.clientAge = 56;
  // }

  output.ltv = getLtvValue(input);
  output.hideChart = !validLoan || !validCapitalValue || (input.loanTaken > output.ltv.max) ||
    (output.yearlyCapitalValue > output.maxYearlyLoan);
  return { input, output };
};

const output = partialRepaymentOutput(defaultInput);
const initialState = updateInputOutput({ input: defaultInput, output });

export default function (state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_INPUT': {
      const {field, value} = action.payload;
      const input = { ...state.input, [field] : value };
      const output = partialRepaymentOutput(input);
      updateInputOutput({ input, output });
      return { ...state, input, output};
    }
    case 'UPDATE_PLAN': {
      const input = { ...state.input };
      input.ltvPlan = action.payload;
      const output = partialRepaymentOutput(input);
      updateInputOutput({ input, output });
      return { ...state, input, output};
    }
    default:
  }
  return state
};



// WEBPACK FOOTER //
// ./src/reducers/partialRepayment.js